import React, { useEffect, useRef, useState } from "react";
import "./why-choose.m.css";
import { LeftArrowIcon } from "../left-arrow-icon";
import { RightArrowIcon } from "../right-arrow-icon";
import { SUBSCRIPTION_PAGE_STRINGS } from "../../../../constants";
import { SliderIndicators } from "../slider-indicators";
import { hardcodedCards, OrangeTickIcon } from "./data";

const WhyChoose = ({ colors = {}, planCard = {}, subscriberCount = {} }) => {
  const s = SUBSCRIPTION_PAGE_STRINGS.PV, [activeIndex, setActiveIndex] = useState(0), scrollRef = useRef(null), sectionRef = useRef(null);
  const scroll = d => scrollRef.current?.scrollBy({ left: d === "left" ? -361 : 361, behavior: "smooth" });
  const hScroll = () => { if (scrollRef.current) setActiveIndex(Math.round((scrollRef.current.scrollLeft / (scrollRef.current.scrollWidth - scrollRef.current.clientWidth)) * 1) || 0); };
  
  useEffect(() => {
    const timer = setInterval(() => {
      if (scrollRef.current) {
        const c = scrollRef.current, maxScroll = c.scrollWidth - c.clientWidth;
        if (maxScroll > 0) {
          const isMobile = typeof window !== "undefined" && window.innerWidth <= 767;
          const step = isMobile ? c.clientWidth : 361;
          let nextScroll = c.scrollLeft + step;
          if (nextScroll > maxScroll + 10) {
            c.scrollTo({ left: 0, behavior: "auto" });
          } else {
            c.scrollTo({ left: nextScroll, behavior: "smooth" });
          }
        }
      }
    }, 4000);
    return () => clearInterval(timer);
  }, [activeIndex]);

  useEffect(() => { if (sectionRef.current) sectionRef.current.querySelectorAll("[data-arrow-border], [data-arrow-icon]").forEach(el => el.setAttribute("stroke", colors.palette2 || "")); }, [colors]);

  return (
    <section styleName="why-section" ref={sectionRef}>
      <h2 styleName="heading" style={colors.text_color ? { color: colors.text_color } : {}}>{s.WHY_CHOOSE_HEADING}</h2>
      <div styleName="carousel">
        <button styleName="arrow" onClick={() => scroll("left")}><LeftArrowIcon /></button>
        <div styleName="viewport">
          <div styleName="cards-container" ref={scrollRef} onScroll={hScroll}>
            {hardcodedCards.map((c, i) => {
              const Icon = c.icon || OrangeTickIcon;
              return (
                <div key={i} styleName="card" style={{ borderColor: colors.palette1 }}>
                  <div styleName="icon-wrapper"><Icon color={colors.palette1} /></div>
                  <div styleName="card-title" style={colors.text_color ? { color: colors.text_color } : {}}>{c.title}</div>
                  <div styleName="card-description" style={colors.text_color ? { color: colors.text_color } : {}}>{c.description}</div>
                </div>
              );
            })}
          </div>
        </div>
        <button styleName="arrow" onClick={() => scroll("right")}><RightArrowIcon /></button>
      </div>
      <SliderIndicators count={2} activeIndex={activeIndex} accentColor={colors.palette2} onClick={(i) => {
        if (scrollRef.current) {
          const maxScroll = scrollRef.current.scrollWidth - scrollRef.current.clientWidth;
          scrollRef.current.scrollTo({ left: i * maxScroll, behavior: "smooth" });
        }
      }} />
      {subscriberCount?.count && (
        <div styleName="subscriber-band" style={{ backgroundColor: colors.palette3 }}>
          <div styleName="subscriber-count" style={{ color: colors.text_color }}>{subscriberCount.count}</div>
          <div styleName="subscriber-label" style={{ color: colors.text_color }}>{subscriberCount.label}</div>
        </div>
      )}
    </section>
  );
};
export { WhyChoose };
